<template>
  <div class="scrollable-container">

    <div
      ref="scrollable"
      @scroll="handleScroll"
      :class="{'fade-top': showFadeTop, 'fade-bottom': showFadeBottom}"
      class="scrollable">
      <div class="scrollable-content" ref="content">
        <slot></slot>
      </div>
    </div>

    <template v-if="showScrollToButtons">
      <div
        v-show="isBottom"
        class="scroll-to-button">
        <slot
          name="scrollUp"
          :scrollToSection="scrollToSection">
        </slot>
      </div>
      <div
        v-show="isTop"
        class="scroll-to-button">
        <slot
          name="scrollDown"
          :scrollToSection="scrollToSection">
        </slot>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  name: 'scrollable',
  props: {
    showScrollToButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollableContentHeight: 0,
      scrollableHeight: 0,
      scrollPos: 0,
      showFadeTop: false,
      showFadeBottom: true,
    };
  },
  computed: {
    isBottom() {
      return this.scrollableContentHeight === this.scrollableHeight + this.scrollPos;
    },
    isTop() {
      return this.scrollPos === 0;
    },
  },
  mounted() {
    this.updateScrollValues();
  },

  methods: {
    handleScroll() {
      this.updateScrollValues();
      // Show top fade if content is not at the very top
      this.showFadeTop = this.scrollPos > 0;
      this.showFadeBottom = this.scrollPos + this.scrollableHeight < this.scrollableContentHeight;
    },
    updateScrollValues() {
      this.scrollableContentHeight = this.$refs.scrollable.scrollHeight;
      this.scrollableHeight = this.$refs.scrollable.clientHeight;
      this.scrollPos = this.$refs.scrollable.scrollTop;
    },
    scrollToSection(id) {
      let pos = 0;

      if (id) {
        const section = this.$el.querySelector(`section#${id}`);
        pos = section.offsetTop;
      }

      this.$refs.scrollable.scrollTo({
        top: pos,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .scrollable-container {
    position: relative;
  }

  .scrollable {
    height: 100%;
    overflow-y: auto;
    // &.fade-top {
    //   -webkit-mask-image: -webkit-linear-gradient(top, rgba(black, 0), rgba(black, 1) 4%);
    // }

    // &.fade-bottom {
    //   -webkit-mask-image: -webkit-linear-gradient(bottom, rgba(black, 0), rgba(black, 1) 12%);
    // }

    // &.fade-top.fade-bottom {
    //   -webkit-mask-image: -webkit-linear-gradient(top, rgba(black, 0), rgba(black, 1) 10%, rgba(black, 1) 96%, rgba(black, 0) 100%);
    // }
  }

  @media only screen and (min-width: 768px) and (orientation: landscape) {
    // Issue #75
    .slide.axi-spinal {
      .scrollable.fade-bottom {
        // -webkit-mask-image: none;
      }
    }
  }

  .scroll-to-button {
    position: absolute;
    bottom: 5px;
    right: 25px;
    font-size: 0.9rem;
    text-align: right;

    span {
      display: flex;
      align-items: center;
    }

    img {
      margin-left: 10px;
    }
  }

</style>
